import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConstantsService {
    TZ_IST = 'Asia/Kolkata';
    DATE_FORMAT: string = 'DD-MM-YYYY';
    DATETIME_FORMAT: string = 'MM-DD-YYYY hh:mm A';
    DATETIME_FORMAT_USER: string = 'DD-MM-YYYY hh:mm A';

    constructor() {
    }

    unsubscribe(subscriptions: any[]) {
        for (const sub of subscriptions) sub.unsubscribe();
    }
}
